import {api2Endpoint} from 'app/config/apiConfig'
import {useCallback, useState} from 'react'
import {GetDataOptions, GetDataResponse} from '../api/useGetData'
import {postData} from '../api/usePostData'

export default function usePostStripeStartPortal(): [
  (jsonObject: any, options?: GetDataOptions<any>) => Promise<any | void>,
  GetDataResponse<any>
] {
  const [data, setData] = useState<any>(undefined)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | undefined>()

  const exec = useCallback(async (jsonObject: any, options?: GetDataOptions<any>) => {
    setLoading(true)

    postData<any>(api2Endpoint('std/stripe/start_portal'), jsonObject)
      .then((response: any) => {
        return response
      })
      .then((response) => {
        setData(response)
        setLoading(false)
        options?.onComplete?.(response)
      })
      .catch((e) => {
        setError(e)
        setLoading(false)
        options?.onError?.(e)
      })
  }, [])
  return [exec, {data, loading, error, setData}]
}
